interface TrashIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const TrashIcon = ({ width = 14, height = 14, className }: TrashIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M12.2501 2.33333H10.4417C10.3064 1.67499 9.94814 1.08345 9.42748 0.658419C8.90681 0.233386 8.25553 0.000848473 7.58342 0L6.41675 0C5.74463 0.000848473 5.09335 0.233386 4.57269 0.658419C4.05202 1.08345 3.6938 1.67499 3.55841 2.33333H1.75008C1.59537 2.33333 1.447 2.39479 1.3376 2.50419C1.22821 2.61358 1.16675 2.76196 1.16675 2.91667C1.16675 3.07138 1.22821 3.21975 1.3376 3.32915C1.447 3.43854 1.59537 3.5 1.75008 3.5H2.33341V11.0833C2.33434 11.8566 2.64193 12.5979 3.18871 13.1447C3.73549 13.6915 4.47682 13.9991 5.25008 14H8.75008C9.52335 13.9991 10.2647 13.6915 10.8115 13.1447C11.3582 12.5979 11.6658 11.8566 11.6667 11.0833V3.5H12.2501C12.4048 3.5 12.5532 3.43854 12.6626 3.32915C12.772 3.21975 12.8334 3.07138 12.8334 2.91667C12.8334 2.76196 12.772 2.61358 12.6626 2.50419C12.5532 2.39479 12.4048 2.33333 12.2501 2.33333ZM6.41675 1.16667H7.58342C7.94524 1.16711 8.29807 1.27947 8.59352 1.48834C8.88897 1.69721 9.11258 1.99237 9.23367 2.33333H4.7665C4.88759 1.99237 5.11119 1.69721 5.40664 1.48834C5.70209 1.27947 6.05492 1.16711 6.41675 1.16667ZM10.5001 11.0833C10.5001 11.5475 10.3157 11.9926 9.98752 12.3208C9.65933 12.649 9.21421 12.8333 8.75008 12.8333H5.25008C4.78595 12.8333 4.34083 12.649 4.01264 12.3208C3.68446 11.9926 3.50008 11.5475 3.50008 11.0833V3.5H10.5001V11.0833Z"
      fill="currentColor"
    />
    <path
      d="M5.83333 10.5002C5.98804 10.5002 6.13642 10.4387 6.24581 10.3293C6.35521 10.2199 6.41667 10.0715 6.41667 9.91683V6.41683C6.41667 6.26212 6.35521 6.11375 6.24581 6.00435C6.13642 5.89495 5.98804 5.8335 5.83333 5.8335C5.67862 5.8335 5.53025 5.89495 5.42085 6.00435C5.31146 6.11375 5.25 6.26212 5.25 6.41683V9.91683C5.25 10.0715 5.31146 10.2199 5.42085 10.3293C5.53025 10.4387 5.67862 10.5002 5.83333 10.5002Z"
      fill="currentColor"
    />
    <path
      d="M8.16659 10.5002C8.32129 10.5002 8.46967 10.4387 8.57906 10.3293C8.68846 10.2199 8.74992 10.0715 8.74992 9.91683V6.41683C8.74992 6.26212 8.68846 6.11375 8.57906 6.00435C8.46967 5.89495 8.32129 5.8335 8.16659 5.8335C8.01188 5.8335 7.8635 5.89495 7.75411 6.00435C7.64471 6.11375 7.58325 6.26212 7.58325 6.41683V9.91683C7.58325 10.0715 7.64471 10.2199 7.75411 10.3293C7.8635 10.4387 8.01188 10.5002 8.16659 10.5002Z"
      fill="currentColor"
    />
  </svg>
);

export default TrashIcon;
